import hasRadioRoute, { hasMenuRoute } from "@/utils/hasRadioRoute";

// Only a radio-only subscriber lands on /radio. The backend always grants
// Users.dashboard and hides Visão 360 only in the radiodasorte segment, so a
// system tenant that also bought the radio still has /visao360 in the menu.
export default function shouldRedirectToRadio(menu) {
  return hasRadioRoute(menu) && !hasMenuRoute(menu, "/visao360");
}
